import { useEntityMutation } from './useEntityMutation';
import { clientMutationConfig } from '@/lib/entity-configs';

/**
 * Hook per crear clients
 * @deprecated Usa useEntityMutation amb clientMutationConfig directament
 */
export function useCreateClient() {
  const { createMutation } = useEntityMutation(clientMutationConfig);
  return createMutation;
}
